import {
  listing,
  type primitives,
  type AuctionBlueprintOnlineReactiveArgs,
} from '@adc/blueprint'
import * as graph from '@adc/sdk'
// @ts-ignore no types
import { safeStringify } from '@adc/core-utils/src/helpers/string'

type BlueprintListing = AuctionBlueprintOnlineReactiveArgs['listing']

type AuctionUser = primitives.AuctionUser

const getMarketingMagicData = ({
  listing,
  user,
}: {
  listing: BlueprintListing
  user: AuctionUser
}) => ({
  feature9: listing.marketing_tags?.map(t => t?.tag).join('|') || '',
  eventCode: listing.event?.event_code,
  propertyState:
    listing?.primary_property?.summary?.address?.country_primary_subdivision,
  propertyCounty:
    listing.primary_property?.summary?.address?.country_secondary_subdivision,
  propertyCity: listing.primary_property?.summary?.address.municipality,
  sellerCode: listing?.seller_plan?.seller_plan_code,
  venueCode: listing.venue?.venue_code,
  listingId: listing.listing_id,
  userAuthentication: user.logged_in ? 'yesLoggedIn' : 'noLoggedIn',
  partyId: user.logged_in ? user.party_id : '',
  listingStatusGroup: listing.listing_status_group,
  listingStatus: listing.listing_status,
  directOffer: listing.listing_configuration?.is_direct_offer_enabled
    ? 'yesDirectOffer'
    : 'noDirectOffer',
  inPersonAuction: !listing?.auction?.is_online
    ? 'yesInPersonAuction'
    : 'noInPersonAuction',
  onlineAuction: listing?.auction?.is_online
    ? 'yesOnlineAuction'
    : 'noOnlineAuction',
  remoteBid:
    listing && listing.__methods__.isRemoteBidEnabled()
      ? 'yesRemoteBid'
      : 'noRemoteBid',
  isReserveMet:
    listing?.online_auction_segment?.reserve_status ===
    graph.enums.ReserveStatus.ReserveMet
      ? 'yesReserveMet'
      : 'noReserveMet',
  condition: listing.listing_configuration?.occupancy_status,
  morpheusPropertyId: listing.primary_property.property_id,
  assetType: listing.listing_configuration?.asset_type,
  firstLookEnabled: listing.listing_configuration?.is_first_look_enabled
    ? 'yesFirstLook'
    : 'noFirstLook',
  brokerCoop: listing.listing_configuration?.broker_commission_message
    ? 'yesBrokerCoop'
    : 'noBrokerCoop',
  isReserveDisplayed: listing.listing_configuration?.is_reserve_displayed
    ? 'yesReserveDisplayed'
    : 'noReserveDisplayed',
  buyerPremiumAvailable: listing.listing_configuration?.buyer_premium_available
    ? 'yesBuyerPremiumAvailable'
    : 'noBuyerPremiumAvailable',
})

export const getMetaContent = (currentListing: any) => {
  let metaContent
  const isPrivateSeller = listing.utils.isPrivateSeller(currentListing)
  if (!isPrivateSeller) {
    metaContent = `Bid on Auction Property ${currentListing.formatted_address} for free! Register today to find other auction properties in ${currentListing?.primary_property?.summary?.address.country_primary_subdivision}.`
  } else {
    const isOfferDisposition =
      listing.utils.getSegmentType(currentListing) ===
      graph.enums.OnlineAuctionSegmentType.SealedBid
    if (isOfferDisposition) {
      metaContent = `Make an offer on ${currentListing.formatted_address}. No bidding, just a simple and secure way to buy on your terms. Register now with SmartSale.`
    } else {
      metaContent = `Bid on ${currentListing.formatted_address}. Compete in real-time and secure your next property through SmartSale. Register now to get started.`
    }
  }
  return metaContent
}

export const getInitMarketingData = (params: {
  listing: BlueprintListing
  user: AuctionUser
}) => `window.MARKETING_DATA = ${safeStringify(getMarketingMagicData(params))}`
